export default __webpack_public_path__ + "static/media/mdi_filter.2c3b0f30.svg";